/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import { gql } from '@apollo/client';

const findOfferInboxQuery = (queryName = 'offerInbox') => (
    gql`query ${queryName}(
    $brand: String!
    $environment: String!
    $user: UserSF!
    $userAttributes: [UserAttributesSF]
    $isHoldoutEligible: Boolean!
    $resolveIdentity: Boolean!
  ) {
    offerInbox(
      brand: $brand
      environment: $environment
      user: $user
      userAttributes: $userAttributes
      resolveIdentity: $resolveIdentity
      isHoldoutEligible: $isHoldoutEligible
    ) {
      availableOffers {
        type
        name
        promoCode
        campaign
        content
      }
      content
    }
  }`
);

export default findOfferInboxQuery;
